import { useIsRobnetEnabled } from "components/ROB/hooks";
import { useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { ApiInstance } from "utils/Api";

export const useContractROBDataQuery = (regNumber?: string, locationId?: number) => {
  const isRobnetEnabled = useIsRobnetEnabled(locationId);

  return useTypedQuery({
    queryKey: AppointmentsQueryKeys.contractROBData,
    queryFn: async ({ baseUrl, endpoint }) => {
      if (!regNumber || !locationId || !isRobnetEnabled) return null;
      const res = await ApiInstance.post(endpoint, { reg_nr: regNumber, location_id: locationId }, baseUrl);
      return res.data ?? null;
    },
    enabled: Boolean(regNumber && locationId && isRobnetEnabled)
  });
};
